import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { ConfirmedResident, Resident, ResidentFormValues } from "../models/resident";
import { store } from "./store";
import SignatureCanvas from 'react-signature-canvas';
import { history } from "../..";

export default class ResidentStore {
    // residentRegistry = new Map<string, Resident>();
    selectedResident: Resident | undefined = undefined;
    confirmedResident: ConfirmedResident | undefined;
    editMode = false;
    loading = false;
    loadingInitial = false;
    // pagination: Pagination | null = null;
    // pagingParams = new PagingParams();
    // predicate = new Map().set('all', true);

    constructor() {
        makeAutoObservable(this);

        // reaction(
        //     () => this.predicate.keys(),
        //     () => {
        //         this.pagingParams = new PagingParams();
        //         this.residentRegistry.clear();
        //         this.loadResidents();
        //     }
        // )
    }

    // setPagingParams = (pagingParams: PagingParams) => {
    //     this.pagingParams = pagingParams;
    // }

    // setPredicate = (predicate: string, value: string | Date) => {
    //     const resetPredicate = () => {
    //         this.predicate.forEach((value, key) => {
    //             if (key !== 'startDate') this.predicate.delete(key);
    //         })
    //     }
    //     switch (predicate) {
    //         case 'all':
    //             resetPredicate();
    //             this.predicate.set('all', true);
    //             break;
    //         case 'isExcludeDefaultCamp':
    //             resetPredicate();
    //             this.predicate.set('isExcludeDefaultCamp', false);
    //             break;            
    //         case 'startDate':
    //             this.predicate.delete('startDate');
    //             this.predicate.set('startDate', value);
    //             break;
    //         case 'endDate':
    //             this.predicate.delete('endDate');
    //             this.predicate.set('endDate', value);
    //             break;
    //     }
    // } 

    // get axiosParams() {
    //     const params = new URLSearchParams();
    //     params.append('pageNumber', this.pagingParams.pageNumber.toString());
    //     params.append('pageSize', this.pagingParams.pageSize.toString());
    //     this.predicate.forEach((value, key) => {
    //         if (key === 'startDate' || key == 'endDate') {
    //             params.append(key, (value as Date).toISOString())
    //         } else {
    //             params.append(key, value);
    //         }
    //     })
    //     return params;
    // }

    // get residentsByDate() {
    //     return Array.from(this.residentRegistry.values()).sort((b, a) => // desc sorting, swap a, b for ascen
    //         a.recordDate!.getTime() - b.recordDate!.getTime());
    // }

    // get groupedResidents() {
    //     return Object.entries(
    //         this.residentsByDate.reduce((residents, resident) => {
    //             const recordDate = format(resident.recordDate!, 'dd MMM yyyy');
    //             residents[recordDate] = residents[recordDate] ? [...residents[recordDate], resident] : [resident];
    //             return residents;
    //         }, {} as {[key: string]: Resident[]})
    //     )
    // }


    // loadResidents = async () => {
    //     this.loadingInitial = true;
    //     try {
    //         const result = await agent.Residents.list(this.axiosParams);
    //         result.data.forEach(resident => {
    //             this.setResident(resident);
    //         })
    //         this.setPagination(result.pagination);
    //         this.setLoadingInitial(false);
    //     } catch (error) {
    //         console.log(error);
    //         this.setLoadingInitial(false);
    //     }
    // }

    // setPagination = (pagination: Pagination) => {
    //     this.pagination = pagination;
    // }

    // loadResident = async (mobileNumber: string) => {
    //     let resident = this.getResident(mobileNumber);
    //     if (resident) {
    //         this.selectedResident = resident;
    //         return resident;
    //     } else {
    //         this.loadingInitial = true;
    //         try {
    //             resident = await agent.Residents.details(id);
    //             this.setResident(resident);
    //             runInAction(() => {
    //                 this.selectedResident = resident;
    //             })
    //             this.setLoadingInitial(false);
    //             return resident;
    //         } catch (error) {
    //             console.log(error);
    //             this.setLoadingInitial(false);
    //         }
    //     }
    // }

    // private setResident = (resident: Resident) => {   
    //     resident.recordDate = new Date(resident.recordDate!);
    //     this.residentRegistry.set(resident.id, resident);
    // }

    // private getResident = (id: string) => {
    //     return this.residentRegistry.get(id);
    // }

    loadResident = async (sid: string) => {
       
        this.loadingInitial = true;
        try {
            let resident = await agent.Residents.details(sid);
            runInAction(() => {
                this.selectedResident = resident;
            })
            this.setLoadingInitial(false);
            return resident;
        } catch (error) {
            console.log(error);
            this.setLoadingInitial(false);
        }
        
    }
  
    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    updateResident = async (resident: ResidentFormValues, signatureCanvas: SignatureCanvas  | null) => {
        try {
            
            
            // console.log(canvas.toDataURL());
            resident.signatureBase64 = signatureCanvas?.getTrimmedCanvas().toDataURL();            
            // console.log('Resident: ' + resident);
               
            if (!resident.fullName) {                
                resident.fullName = resident.firstName + ' ' + resident.surname;             
            }

            await agent.Residents.update(resident);
            // runInAction(() => {
            //     if (resident.signatureData) {
            //         let updatedResident = {...this.getResident(resident.id), ...resident}
            //         this.residentRegistry.set(resident.id, updatedResident as Resident);
            //         this.selectedResident = updatedResident as Resident;
            //     } 
            // })
            runInAction(() => {
                this.confirmedResident = new ConfirmedResident(resident);
                // this.confirmedResident.signatureData = signatureCanvas?.toData();
                // console.log(this.confirmedResident.signatureData );
                this.clearSelectedResident();
            })
            history.push('/confirm');
            store.modalStore.closeModal();
        } catch (error) {
            console.log('error saving resident ' + error);
            throw error;
        }
    }

    clearSelectedResident = () => {
        this.selectedResident = undefined;
    }
}